import { render } from "./SharedStreamPlaceholder.vue?vue&type=template&id=b012fa46&scoped=true"
import script from "./SharedStreamPlaceholder.vue?vue&type=script&lang=js"
export * from "./SharedStreamPlaceholder.vue?vue&type=script&lang=js"

import "./SharedStreamPlaceholder.vue?vue&type=style&index=0&id=b012fa46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b012fa46"

export default script